"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FeatureTextComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("@ux/button"));
var _tooltip = _interopRequireDefault(require("@ux/tooltip"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
require("@ux/tooltip/styles");
var _storeProvider = require("./../util/storeProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class FeatureTextComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.tooltipRef = /*#__PURE__*/_react.default.createRef(null);
    this.state = {
      showTooltip: false
    };
  }
  render() {
    const {
      store
    } = this.context;
    const {
      content,
      isMobile,
      indentClass = ''
    } = this.props;
    if (!content['feature-text'] && !content['feature-text-2']) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `col-xs-12 col-sm-11 feature-text-2 ${indentClass} ${isMobile ? 'mt-2' : ''}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mb-1"
    }, content['feature-text'] && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-black"
    }, store.parseHtml(content['feature-text']))), /*#__PURE__*/_react.default.createElement("br", null)), content['feature-text-2'] && store.parseHtml(content['feature-text-2']), content['tooltip-text'] && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      ref: this.tooltipRef,
      onClick: () => {
        this.setState({
          showTooltip: !this.state.showTooltip
        });
      },
      icon: /*#__PURE__*/_react.default.createElement(_help.default, null),
      "aria-describedby": "button-hint"
    }), this.state.showTooltip && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      id: "button-hint",
      anchorRef: this.tooltipRef,
      open: this.state.showTooltip,
      onClose: () => {
        this.setState({
          showTooltip: false
        });
      },
      placement: "top"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "mb-0 text-left"
    }, store.parseHtml(content['tooltip-text'])))))));
  }
}
exports.FeatureTextComponent = FeatureTextComponent;
FeatureTextComponent.propTypes = {
  indentClass: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  content: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _storeProvider.provideContext)(FeatureTextComponent);